export const scrollToSection = (sectionId: string) => {
  const sectionElement = document.getElementById(sectionId);
  const offset = 128;
  if (sectionElement) {
    const targetScroll = Math.max(sectionElement.offsetTop - offset, 0);
    window.scrollTo({
      top: targetScroll,
      behavior: 'smooth',
    });
  }
};
